module.exports = __webpack_public_path__ + "static/media/buyer-inner-bg.0b6516fc.png";